import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continue: 'Access to my account',
    description: 'We will review it and come back to you if needed.',
    headline: 'Your document has been sent',
  },
  fr: {
    continue: 'Accéder à mon compte',
    description:
      'Nous allons le vérifier rapidement\net nous vous recontacterons en cas de besoin.',
    headline: 'Votre document\na bien été envoyé',
  },
});

export default locales;
